<portal-navbar></portal-navbar>
@if (isMPOV2Enabled && isOnLegacyMPODashboard) {
  <m-messages
    [messages]="[
      {
        severity: 'error',
        detail:
          'Please use the Media Plan Optimizer v2 (Beta). This version will soon be removed.',
        icon: 'warning_amber',
      },
    ]"
    [fullScreen]="true"
    [closable]="false">
  </m-messages>
}
<div class="container-fluid main-container g-0" id="main-container-id">
  <div class="row g-0">
    <section
      class="col-md-12 position-relative main-content"
      [ngClass]="{
        'tableau-content': isTableauUriPath,
      }">
      @if (serverErrorState.hasError) {
        <div
          class="flex flex-col justify-center items-center h-full min-h-screen">
          <m-empty-states
            [size]="EmptyStateSize.intermediate"
            title="Server Temporarily Unavailable"
            description="The server is currently experiencing issues. Please try again in a few moments."
            [stateType]="EmptyStateType.dataNotAvailableError">
          </m-empty-states>
        </div>
      } @else {
        <router-outlet></router-outlet>
      }
    </section>
  </div>
</div>
<portal-footer class="portal-footer"></portal-footer>

@if (aiPanelService.isEnabled()) {
  <portal-ai-assistant-panel />
}
